export type ApiOtherDimensionValues = null;

type ApiSpecificValue = string;
type ApiUnassignedValues = null;
type ApiSpecifiedValue = ApiSpecificValue | ApiUnassignedValues;

/**
 * Dimension values type used by backend API.
 */
export type ApiDimensionValues = ApiSpecifiedValue[] | ApiOtherDimensionValues;

export const otherValuesId = '__other__';
export const unassignedValuesId = '__unassigned__';

/**
 * Constraint: Must be a single value per dimension.
 */
export type OtherValuesId = typeof otherValuesId;

/**
 * Constraint: Must be a single value per dimension.
 */
export type UnassignedValuesId = typeof unassignedValuesId;

type DimensionValueSpecificId = { type: 'specific'; value: string };
type DimensionValueUnassignedId = {
  type: 'unassigned';
  value: UnassignedValuesId;
};
type DimensionValueOtherId = { type: 'other'; value: OtherValuesId };

/**
 * Dimension value for domain use.
 */
export type DimensionValueId =
  | DimensionValueSpecificId
  | DimensionValueUnassignedId
  | DimensionValueOtherId;
